<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Create New Experiment'"
        @cancel="closeModal"
        @create="createTrainer"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 settings__control-group">
              <label>Project: {{ project.name }}</label>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 settings__control-group">
              <label class="required">Name</label>
              <input
                v-model="name"
                class="select"
                type="text"
              >
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 settings__control-group">
              <label>Description</label>
              <textarea
                v-model="description"
                rows="2"
              />
            </div>
          </div>
          <div v-if="message" class="row mt-3">
            <div class="col-12 settings__control-group">
              <div>
                <span>{{ message }}</span>
              </div>
            </div>
          </div>
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';
import { event } from 'vue-gtag';

export default {
  name: 'CreateTrainerModal',
  components: {
    BaseDialog,
  },
  props: {
    trainer: {
      type: Object,
      default: () => null,
    },
    project: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['trainer-created', 'trainer-updated'],
  data() {
    return {
      localShow: false,
      message: '',
      name: '',
      description: "",
    };
  },
  computed: {
    currentProject() {
      return this.$store.state.projects.currentProject;
    },
  },
  mounted() {

  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  methods: {
    showModal() {
      this.localShow = true;
      this.initializeModal();
    },
    closeModal() {
      this.localShow = false;
      this.initializeModal();
    },
    initializeModal() {
      this.message = '';
      if (this.trainer) {
        this.name = this.trainer.name;
        this.project_id = this.project.id;
      } else {
        this.name = '';
        this.description = '';
      }
    },
    async createTrainer() {
      if (!this.name) {
        this.message = `Missing Trainer name`;
        return;
      }

      await this.dataConnect.addTrainer({
        project_id: this.currentProject.id,
        name: this.name,
        description: this.description,
      })
        .then((data) => {
          if (data.result) {
            event('create_experiment_success', {
              category: 'create_experiment',
              label: 'User successfully created an experiment',
              user: this.$store.state.user.user.username,
            });
            this.localShow = false;
            this.$emit('trainer-created', data.result);
          } else if (data.error) {
            event('create_experiment_failure', {
              category: 'create_experiment',
              label: 'User failed to create an experiment',
              user: this.$store.state.user.user.username,
              reason: data.error.message,
            });
            this.message = data.error.message;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};

</script>

<style lang="scss" scoped>

.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

